function loadCharts(chartLabelLimit, endpoint, chartId, type, options) {
  var trim_chart_labels = function(data) {
    return data.map(function(row) {
      var limit = chartLabelLimit;
      if (row[0].length  > limit) {
        return [row[0].substring(0,limit)+'...', row[1]];
      } else {
        return row;
      }
    });
  };

  var request = function() {
    $.ajax({
      url: endpoint,
      dataType: 'json',
      error: function(response) {
        setTimeout(request, 5000);
      },
      success: function(data) {
        var selector = "chart-" + chartId;
        var chart_data = type == 'PieChart' ? trim_chart_labels(data.data) : data.data;
        new Chartkick[type](selector, chart_data, {"library": options });
        var question = $('#' + selector).closest('.js-question');
        var tbody = $('tbody', question);
        data.data.forEach(function(row, index) {
          var percent = '-';
          if (parseFloat(data.count) > 0) {
            percent = (parseFloat(row[1]) / parseFloat(data.count)) * 100;
          }
          $('<tr><td>' + row[0] + '</td><td>' + row[1] + '</td><td>' + Math.round(percent).toString() + '</td></tr>').appendTo(tbody);
        });
      }
    });
  }
  request();
}


/*** EXPORTS FROM exports-loader ***/
module.exports = loadCharts;